/**
 * Сжимает изображение на клиенте с помощью canvas.
 *
 * @param {File} file - Исходный файл изображения (например, из <input type="file" />).
 * @param {number} [quality=0.7] - Качество JPEG-сжатия от 0 до 1.
 *                                 1 — без потерь, 0 — минимальное качество.
 * @returns {Promise<File>} Новый файл изображения в формате JPEG, уменьшенный
 *                          по ширине до 800px (с сохранением пропорций).
 *
 * @throws {Error} Если не удалось сжать изображение или произошла ошибка чтения файла.
 *
 * @example
 * const input = document.querySelector('input[type="file"]');
 * input.onchange = async (e) => {
 *   const file = e.target.files[0];
 *   if (!file) return;
 *
 *   try {
 *     const compressed = await compressImage(file, 0.6);
 *     console.log("Размер до:", (file.size / 1024).toFixed(2), "KB");
 *     console.log("Размер после:", (compressed.size / 1024).toFixed(2), "KB");
 *   } catch (err) {
 *     console.error("Ошибка:", err);
 *   }
 * };
 */


export const compressImage = (file, quality = 0.7) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const canvas = document.createElement('canvas');

                // Можно задать максимальную ширину (например, 800px)
                const MAX_WIDTH = 800;
                const scaleSize = MAX_WIDTH / img.width;
                canvas.width = MAX_WIDTH;
                canvas.height = img.height * scaleSize;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            const compressedFile = new File([blob], file.name, {
                                type: 'image/jpeg',
                                lastModified: Date.now(),
                            });
                            resolve(compressedFile);
                        } else {
                            reject(new Error("Не удалось сжать изображение"));
                        }
                    },
                    'image/jpeg',
                    quality // от 0 до 1
                );
            };

            img.onerror = reject;
        };

        reader.onerror = reject;
    });
};